import React, { useState, useContext, useRef } from "react";
import LiteCurrencySelector from "./LiteCurrencySelector";
import { SettingsContext } from "./AccountSettingsButton";
import jsDig from "utils/jsDig.js";
import ClientUsers1 from "./ClientUsers1";
import AccountUsers from "client_config/lite/AccountUsers";
import AddUser from "client_config/lite/AddUser";

export default function Access() {
  const props = useContext(SettingsContext);

  let teamAccess = require("images/lite/icons/teamAccess.png");
  teamAccess = <img className="access-icon" alt="teamAccess" src={`/datapulse${teamAccess}`} />;

  let handshake = require("images/lite/icons/handshake.png");
  handshake = <img className="access-icon" alt="handshake" src={`/datapulse${handshake}`} />;

  return (
    <div className="lite-access-container">
      <div className="client-access">
        <div className="heading-row">
          {handshake} <p>Client Access</p>
        </div>
        <AccountUsers userType="client" />
      </div>
      <div className="team-access">
        <div className="heading-row">
          {teamAccess} <p>Team Access</p>
        </div>
        <AccountUsers userType="employee" />
      </div>
    </div>
  );
}
